import { render } from "./CounterInfo.vue?vue&type=template&id=20ef4956&ts=true"
import script from "./CounterInfo.vue?vue&type=script&lang=ts"
export * from "./CounterInfo.vue?vue&type=script&lang=ts"

import "./CounterInfo.vue?vue&type=style&index=0&id=20ef4956&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__